import { forwardRef, useCallback } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { EllipsisText } from '@vk-hr-tek/ui/EllipsisText';
import { RedirectCard } from '@vk-hr-tek/ui/RedirectCard';
import { Avatar } from '@vk-hr-tek/ui/Avatar';
import { getInitials } from '@vk-hr-tek/ui/format';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { useInject } from '@vk-hr-tek/core/ioc';

import { useSelector, useIsWidget } from '@app/hooks';
import { modules } from '@app/modules';

import { UserApiService } from '../../../../user/services';
import { selectUser } from '../../../../user';
import { useUrlWithPrefix } from '../../../hooks';

interface UserCardProps {
  onClick: () => void;
  userFullName: string;
}

export const UserCard = forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ onClick, userFullName }: UserCardProps, ref) => {
    const userApiService = useInject(UserApiService);
    const urlWithPrefix = useUrlWithPrefix();
    const isWidget = useIsWidget();

    const user = useSelector(selectUser);

    const loadPhoto = useCallback(async () => {
      const res = await userApiService.getUserPhoto({
        user_id: user?.id ?? '',
      });

      return res.file;
    }, [userApiService, user?.id]);

    return (
      <Box
        width={268}
        mt={isWidget ? '16' : { md: '16', xs: '0' }}
        mb={isWidget ? '8' : { md: '8', xs: '0' }}
        mx="16"
      >
        <RedirectCard
          onClick={onClick}
          {...urlWithPrefix(`/${modules.user.basename}`)}
        >
          <Avatar loadPhoto={loadPhoto} children={getInitials(userFullName)} />

          <EllipsisText>
            <Typography variant="body3">{userFullName}</Typography>
          </EllipsisText>
        </RedirectCard>
      </Box>
    );
  },
);
